<template>
<div class="set-password-container">
<el-card class="set-password-form">
<div class="form-header">
<h2>设置密码</h2>
<p>请为您的账户设置一个密码</p>
</div>

<el-form ref="setPasswordForm" :model="setPasswordForm" :rules="setPasswordRules" label-width="0">
<el-form-item prop="password">
<el-input 
v-model="setPasswordForm.password" 
type="password" 
placeholder="请输入密码"
prefix-icon="el-icon-lock"
show-password>
</el-input>
</el-form-item>

<el-form-item prop="confirmPassword">
<el-input 
v-model="setPasswordForm.confirmPassword" 
type="password" 
placeholder="请确认密码"
prefix-icon="el-icon-lock"
show-password>
</el-input>
</el-form-item>

<el-form-item>
<el-button 
type="primary" 
class="submit-btn" 
:loading="submitting"
@click="handleSetPassword">
设置密码
</el-button>
</el-form-item>
</el-form>

<div class="form-footer">
<p>密码设置完成后，您可以使用手机号+密码的方式登录</p>
</div>
</el-card>
</div>
</template>

<script>
export default {
name: 'SetPassword',
data() {
const validateConfirmPassword = (rule, value, callback) => {
if (!value) {
callback(new Error('请确认密码'));
} else if (value !== this.setPasswordForm.password) {
callback(new Error('两次输入的密码不一致'));
} else {
callback();
}
};

return {
setPasswordForm: {
password: '',
confirmPassword: ''
},
setPasswordRules: {
password: [
{ required: true, message: '请输入密码', trigger: 'blur' },
{ min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
],
confirmPassword: [
{ required: true, message: '请确认密码', trigger: 'blur' },
{ validator: validateConfirmPassword, trigger: 'change' }
]
},
submitting: false
}
},
computed: {
phone() {
return this.$route.query.phone || this.$store.state.user?.phone;
}
},
mounted() {
if (!this.phone) {
this.$message.error('缺少手机号信息');
this.$router.push('/login');
}
// 重置表单验证状态
this.$nextTick(() => {
this.$refs.setPasswordForm?.clearValidate();
});
},
methods: {
async handleSetPassword() {
// 手动验证表单
const valid = await this.$refs.setPasswordForm.validate();
if (valid) {
this.submitting = true;
try {
const response = await this.$http.post('/api/auth/set-password', {
phone: this.phone,
password: this.setPasswordForm.password
});

this.$message.success('密码设置成功');

// 更新用户信息
if (this.$store.state.user) {
this.$store.commit('updateUser', {
...this.$store.state.user,
phone: this.phone
});
}

// 跳转到仪表板
this.$router.push('/dashboard');
} catch (error) {
console.error('设置密码失败:', error);
const errorMsg = error.response?.data?.error || '设置密码失败';
this.$message.error(errorMsg);
} finally {
this.submitting = false;
}
} else {
console.log('表单验证失败');
}
}
}
}
</script>

<style scoped>
.set-password-container {
display: flex;
justify-content: center;
align-items: center;
min-height: 100vh;
background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
padding: 20px;
}

.set-password-form {
background: white;
padding: 40px;
border-radius: 10px;
box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
width: 100%;
max-width: 400px;
}

.form-header {
text-align: center;
margin-bottom: 30px;
}

.form-header h2 {
color: #303133;
margin-bottom: 10px;
}

.form-header p {
color: #909399;
margin: 0;
}

.submit-btn {
width: 100%;
}

.form-footer {
text-align: center;
margin-top: 20px;
padding-top: 20px;
border-top: 1px solid #ebeef5;
}

.form-footer p {
color: #909399;
margin: 0;
font-size: 14px;
}
</style>
